import { fromNode } from '@rehaje/core'
import { reactive, untrack } from '@rehaje/reactive'
import { keys } from '@rehaje/shared'

import { ValuableModel } from '../../models'

import type { SchemaNode } from '../../models'
import type { SchemaObjectNode } from './TypedNode'

export class SchemaObjectModel extends ValuableModel {
  @fromNode()
  @reactive()
  maxProperties?: number

  @fromNode()
  @reactive()
  minProperties?: number

  @reactive('computed')
  get additionalKeys() {
    const propertyKeys = this.getTypedNode<SchemaObjectNode>().propertyKeys
    return keys(this.value ?? {}).filter((key) => !propertyKeys.includes(key))
  }

  @reactive('computed')
  get additionalProperties(): SchemaNode[] {
    const additionalKeys = this.additionalKeys
    return untrack(() => {
      const node = this.getTypedNode<SchemaObjectNode>()
      if (!node.additionalProperties) return []
      return additionalKeys
        .map((key) =>
          node.spawn(['additionalProperties', key], {
            ...node.additionalProperties,
            id: key,
            name: key
          } as SchemaNode)
        )
        .filter(Boolean) as SchemaNode[]
    })
  }

  constructor(node: SchemaObjectNode) {
    super(node)
    if (node.additionalProperties) {
      this.addReaction(
        () => this.additionalProperties,
        (next, prev) => {
          prev?.forEach((child) => child.dispose())
        }
      )
    }
  }

  /**
   * 渲染节点
   */
  override render() {
    const node = this.getTypedNode<SchemaObjectNode>()
    const children = node.properties
      .concat(this.additionalProperties)
      .map((child) => {
        return child.render()
      })
    return super.render(children)
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Object': SchemaObjectModel
  }
}
